import { DatePipe, registerLocaleData } from '@angular/common';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import localeBr from '@angular/common/locales/pt';
import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
  inject,
  provideZoneChangeDetection
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  TitleStrategy,
  provideRouter,
  withComponentInputBinding
} from '@angular/router';

import { provideAnalytics } from '@gruposaltaedu/liv-analytics';
import { provideNgIconLoader, withCaching } from '@ng-icons/core';
import { provideNgxMask } from 'ngx-mask';

import { environment } from '@env/environment';

import { routes } from './app.routes';
import { provideGlobalErrorHandler } from './core/errors/handlers/global-error-handler.service';
import { httpInterceptorProviders } from './core/interceptors';
import { MwTitleStrategy } from './core/navigation/mw-title.strategy';
import { provideOverlayStacking } from './core/ui/components/modal/overlay-stacking.provider';
import {
  TOAST_CONFIG,
  ToastConfig
} from './core/ui/components/toast/toast-config';

registerLocaleData(localeBr, 'pt-BR');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideNgxMask({
      validation: false
    }),
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
    { provide: TitleStrategy, useClass: MwTitleStrategy },
    provideRouter(routes, withComponentInputBinding()),
    DatePipe,
    httpInterceptorProviders,
    provideGlobalErrorHandler(),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    provideOverlayStacking(),
    {
      provide: TOAST_CONFIG,
      useValue: {
        maxCount: 5,
        defaultPosition: 'top-center'
      } as ToastConfig
    },
    provideAnalytics({
      project: 'my-world',
      baseUrl: environment.apiUrl
    })
  ]
};
